export enum StatusContratoEnum {
  NAO_INFORMADO = 0,
  NAO_PUBLICADO,
  VIGENTE,
  ENCERRADO,
  SUSPENSO,
  CANCELADO,
}

// Mapeamento para exibição
export const StatusContratoLabels: Record<StatusContratoEnum, string> = {
  [StatusContratoEnum.NAO_INFORMADO]: 'Não informado',
  [StatusContratoEnum.NAO_PUBLICADO]: 'Não Publicado',
  [StatusContratoEnum.VIGENTE]: 'Vigente',
  [StatusContratoEnum.ENCERRADO]: 'Encerrado',
  [StatusContratoEnum.SUSPENSO]: 'Suspenso',
  [StatusContratoEnum.CANCELADO]: 'Cancelado',
};

// Mapeamento para códigos/slugs
export const StatusContratoCodes: Record<StatusContratoEnum, string> = {
  [StatusContratoEnum.NAO_INFORMADO]: '',
  [StatusContratoEnum.NAO_PUBLICADO]: 'N',
  [StatusContratoEnum.VIGENTE]: 'P',
  [StatusContratoEnum.ENCERRADO]: 'E',
  [StatusContratoEnum.SUSPENSO]: 'S',
  [StatusContratoEnum.CANCELADO]: 'C',
};

export const getStatusContratoOptions = () => {
  return Object.values(StatusContratoEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value as StatusContratoEnum,
      label: StatusContratoLabels[value as StatusContratoEnum],
      code: StatusContratoCodes[value as StatusContratoEnum],
    }));
};

export const getStatusContratoSlug = (
  statusContrato: StatusContratoEnum,
): string => {
  return StatusContratoCodes[statusContrato] || 'Desconhecido';
};

export const getStatusContratoLabel = (
  statusContrato: StatusContratoEnum,
): string => {
  return (
    StatusContratoLabels[statusContrato] || 'Status do Contrato Desconhecido'
  );
};

export const getStatusContratoPorCodigo = (
  code: string,
): StatusContratoEnum | undefined => {
  const entry = Object.entries(StatusContratoCodes).find(
    ([, value]) => value === code,
  );
  return entry ? (Number(entry[0]) as StatusContratoEnum) : undefined;
};

export const getStatusContratoLabelPorSlug = (slug: string): string => {
  const statusContrato = getStatusContratoPorCodigo(slug);

  if (statusContrato !== undefined) {
    return getStatusContratoLabel(statusContrato);
  }

  return 'Status do Contrato Desconhecido';
};
